import classNames from 'classnames'
import React from 'react'
import { Tag } from '../../types/Tag'
import styles from './category-tag.module.scss'
interface Props {
  tag: Tag
  className?: string
  size?: 'large' | 'normal'
}

const CategoryTag = (props: Props) => {
  const { tag, className = '', size = 'normal' } = props

  const classNameTag = classNames(styles.tag, `${className}`, {
    [styles[size]]: true,
  })
  return (
    <a className={classNameTag} href={tag.url}>
      <p className={styles.tagUrl}>{tag.name}</p>
    </a>
  )
}

export default CategoryTag
